module.exports = "<div class=\"outer\" *ngIf=\"data\">\n\t<table class=\"{{tableCssClass}}\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th *ngFor=\"let headerElement of data.header\">{{headerElement}}</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr *ngFor=\"let rowElement of data.rows\">\n\t\t\t\t<td *ngFor=\"let rowData of rowElement.rowData\" title=\"{{rowElement.rowHover}}\">{{rowData}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t<tfoot>\n\t\t\t<tr>\n\t\t\t\t<td *ngFor=\"let footerElement of data.footer\">{{footerElement}}</td>\n\t\t\t</tr>\n\t\t</tfoot>\n\t</table>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/data-table/data-table.html
// module id = JnrD
// module chunks = 12